import { get, map, values } from 'lodash';

import { MINI_NAV_POSITIONS } from 'components/MiniNavigation/constants';
import { OVERLAY_POSITIONS } from 'constants/homepage';
import Model from 'models';
import HeroSlide from 'models/HeroSlide';

const HeroModel = class extends Model {
  get defaultHeroSlidesData() {
    return this._data.heroSlides;
  }

  get heroSlides() {
    const slidesData = this.defaultHeroSlidesData;

    return map(slidesData, slideData => new HeroSlide(slideData));
  }

  get miniNavigationPosition() {
    return get(this._data, ['miniNavigationPosition'], MINI_NAV_POSITIONS.BOTTOM_LEFT);
  }

  get overlayPositionDesktop() {
    const position = get(this._data, 'overlayPosition');

    if (values(OVERLAY_POSITIONS).includes(position)) {
      return position;
    }

    return OVERLAY_POSITIONS.CENTER;
  }

  get overlayPositionMobile() {
    const position = get(this._data, 'overlayPositionMobile');

    if (values(OVERLAY_POSITIONS).includes(position)) {
      return position;
    }

    return OVERLAY_POSITIONS.CENTER;
  }

  get videoUrl() {
    const data = get(this._data, 'video');

    return get(data, ['file', 'url']);
  }

  get decisionId() {
    return get(this._data, 'decisionId');
  }

  get variationId() {
    return get(this._data, 'variationId');
  }
};

export default HeroModel;
